import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    outerContainer: {
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingBottom: '4.5rem',
    },
    container: {
      marginTop: '8px',
    },
    labelContainer: {
      marginBottom: '10px',
    },
    label: {
      fontSize: '1.6rem',
    },
    formContainer: {
      paddingTop: '2rem',
      paddingBottom: '2rem',
      paddingLeft: '1rem',
      marginTop: '1rem',
      paddingRight: '1.5rem',
    },
    formLabelContainer: {
      marginTop: '20px',
      marginBottom: '15px',
    },
    cancelContainer: {
      textAlign: 'right',
      margin: '-24px',
    },
    imageContainer: {
      display: 'block',
      height: '200px',
      width: '100%',
    },
    image: {
      height: '100%',
      width: '100%',
    },
    dropzoneContainer: {
      minHeight: '150px',
    },
    dropzoneText: {
      fontSize: '1.2rem',
      marginTop: '1rem',
      marginBottom: '0.5rem',
    },
    formBottomContainer: {
      zIndex: '1000 !important',
      position: 'fixed !important',
      bottom: '0 !important',
      width: '100% !important',
      left: '0 !important',
    },
    buttonsContainer: {
      height: '60px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingRight: '1.5rem',
    },
    savebutton: {
      marginLeft: '1rem',
    },
    breadcrumbsContainer: {
      position: 'sticky',
      zIndex: '1000',
      top: '0',
      marginTop: '-16px',
      marginLeft: '-25px',
      marginRight: '-25px',
      paddingLeft: '16px',
    },
    breadcrumbsContainerForUsers: {
      position: 'sticky',
      zIndex: '1000',
      top: '75px',
      marginTop: '-16px',
      marginLeft: '-15px',
      marginRight: '-25px',
    },
    breadcrumbsContainerForAdmins: {
      position: 'sticky',
      zIndex: '1000',
      top: '0px',
      marginTop: '-28px',
      marginLeft: '-15px',
      marginRight: '-25px',
    },
    breadcrumbItem: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      color: theme.palette.text.primary,
      padding: '4px 0px',
    },
    activeBreadcrumbItem: {
      color: theme.palette.primary.main,
    },
    breadcrumpIcon: {
      marginRight: '5px',
      fontSize: '18px',
    },
    breadcrumpLabel: {
      fontSize: '14px',
    },
    circleContainer: {
      height: '153px',
      width: '153px',
      margin: 'auto',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
    },
    circleImage: {
      borderRadius: '50%',
      objectFit: 'contain',
    },
  };
});
